import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientStatusManagerComponent } from './client-status-manager.component';
import {FormsModule} from '@angular/forms';
import {ReservationService} from '../../trip-reservations/reservations.service';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';
import {DirectivesModule} from '../../../directives/directives.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Trip2ThemeModule,
    DirectivesModule
  ],
  declarations: [ClientStatusManagerComponent],
  exports: [ClientStatusManagerComponent],
  providers: [
    ReservationService
  ]
})
export class ClientStatusManagerModule { }



// WEBPACK FOOTER //
// ./src/app/pages/clientModules/client-status-manager/client-status-manager.module.ts